export const SIGNAL_TEMPERATURE_EXPLAIN_MESSAGE =
  '시그널온도는 다른 사용자로부터 받은 리뷰, 신고, 운영자 제재 등을 종합해서 만든 매너 지표입니다.';

export const SLOGAN_MESSAGE =
  '"매치업! 보드게임을 즐기는 사람들을 찾는 최적의 장소."';
export const SLOGAN_MESSAGE1 = '"매치업! 보드게임을 즐기는';
export const SLOGAN_MESSAGE2 = '사람들을 찾는 최적의 장소."';

export const AGREE_TERMS_MESSAGE = '(필수) 보드시그널 약관 및 동의사항';
export const AGREE_MARKETING_MESSAGE = '(선택) 마케팅 정보 수신 동의';
